import request from '@/utils/request'
import apiDefine from '@/api/apiDefine'
import datasource from '@/biz/datasource'

class dataGet {
  constructor(dataKey, dataType, requestParam, method) {
    this.dataKey = dataKey
    this.dataType = dataType
    this.requestParam = requestParam
    this.method = method
  }
  async getData() {
    if (this.dataType == 'local') {
      return new Promise((resolve) => {
        resolve(datasource[this.dataKey])
      })
    } else {
      let api = apiDefine[this.dataKey]
      let requestParam = this.requestParam
      let res = await request({
        url: api,
        method: this.method,
        requestParam,
      })
      if (res) {
        return res.list
      }
      return []
    }
  }
}

export default dataGet
